import { Acl } from './acl';
import { EnumOrganizationAccessLevels } from './enum-organization-access-levels';
import { EnumUserAccessLevels } from './enum-user-access-levels';
import { Property } from './property';

export class User {
  public display!: string;
  public account!: string;
  public password!: string;
  public properties: Property[] = [];
  public rights: Acl[] = [];
  public billing!: string;
  public networks!: string;
  public id!: string;
  public enabled: boolean = true;
  public createdAt?: Date;
  public updatedAt?: Date;
  public deletedAt?: Date;
  public lastConnection?: Date;
  public lastSource!: string;
  public siteId!: string;
  public appData!: string;
  public organizationId!: string;
  public displayParentOrganization!: string;
  public organizationPath!: string;
  public ownerId!: string;
  public organizationAccessLevel: EnumOrganizationAccessLevels =
    EnumOrganizationAccessLevels.None;
  public userAccessLevel: EnumUserAccessLevels = EnumUserAccessLevels.None;
  public passwordAttemps?: number;
  public passwordUpdate?: Date;

  public nexusProfil?: string;
  public isNexusAdmin?: boolean;
}
